import React from 'react'
import cx from 'classnames'

export default ({ size, direction, iconName, svgStyle = {}, useStyle = {}, ...props }) => (
  <svg {...props} className={cx('icon', { [`icon--${size}`]: size, [`icon--${direction}`]: direction }, props.className)} style={svgStyle}>
    <use xlinkHref={`#${iconName}`} style={useStyle} />
  </svg>
)
